import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { EmpresaInterna } from '../classes/EmpresaInterna';

@Injectable({
  providedIn: 'root'
})
export class EmpresaInternaService {

  public empresaInternaSelecionada: EmpresaInterna;

  constructor(private http: HttpClient) { }

  getEmpresasInternas(): Observable<any>{
    return this.http.get(`${environment.apiURL}/EmpresaInterna`)
  }

  getEmpresaInterna(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/EmpresaInterna/${id}`)
  }

  postEmpresaInterna(empresaInterna: EmpresaInterna): Observable<any>{
    return this.http.post(`${environment.apiURL}/EmpresaInterna`, empresaInterna);
  }

  putEmpresaInterna(id: number, empresaInterna: EmpresaInterna): Observable<any>{
    return this.http.put(`${environment.apiURL}/EmpresaInterna/${id}`, empresaInterna);
  }

  deleteEmpresaInterna(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/EmpresaInterna/${id}`);
  }

}
